import { Injectable } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { IGridViewMetadata, IRecalculateFilterQuery } from "@tylertech/tyler-api-types";

export enum ApplyTypes
{
    ApplySel = "cmdApplySel",
    Apply = "cmdApply",
    SearchButton = "SearchButton"
}

export enum FilterTypes
{
    Odata = "gridOdata",
    Prompt = "gridPrompt",
}

@Injectable({ providedIn: "root" })
export class GridQueryService
{
    filterQuery: IRecalculateFilterQuery;
    prompt: string;
    odata: string;

    get hasQuery(): boolean
    {
        return !Utilities.IsNullOrUndefined(this.prompt) || !Utilities.IsNullOrUndefined(this.odata);
    }

    buildFilterQueryParam(gridViewMetadata?: IGridViewMetadata): void
    {
        if (this.odata)
            this.filterQuery = <IRecalculateFilterQuery>{
                Odata: this.odata,
                Type: gridViewMetadata.GridProperties.ClassMetadata.TypeName,
                SubPropertyName: gridViewMetadata.SubPropertyName
            };
        else
            this.filterQuery = <IRecalculateFilterQuery>{
                Prompt: this.prompt,
                Type: gridViewMetadata.GridProperties.ClassMetadata.TypeName,
                SubPropertyName: gridViewMetadata.SubPropertyName,
                Properties: gridViewMetadata.GridProperties.ClassMetadata.Properties.map(x => x.Name)
            };
    }

    clearQuery(): void
    {
        this.filterQuery = undefined;
        this.prompt = undefined;
        this.odata = undefined;
    }
}
